<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              {{ $t("consentform.consented") }}
            </h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5 pb-5>
          <v-flex xs11 lg11>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="rounded-lg">
                <v-card-title primary-title>
                  {{ $t("consentform.title") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 lg10>
                      <v-row>
                        <v-col cols="12" md="6">
                          <b class="red--text mr-1">*</b>
                          <b>{{ $t("consentform.subject") }} </b>
                          <br />
                          <v-text-field
                            outlined
                            dense
                            color="#077893"
                            v-model="HeaderConsent"
                            :label="$t('consentform.speconsent')"
                            :rules="[
                              (v) => !!v || $t('consentform.sepconsent2'),
                            ]"
                          >
                          </v-text-field>
                          <b class="red--text mr-1">*</b>
                          <b>{{ $t("consentform.exdate") }}</b>
                          <br />
                          <v-text-field
                            hide-details
                            type="number"
                            color="#077893"
                            :label="$t('consentlist.expiration')"
                            min="1"
                            v-model="ExpireIn"
                            :rules="[(v) => !!v || $t('consentform.exdate2')]"
                            outlined
                            dense
                            clearable
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <!-- <b class="red--text mr-1">*</b> -->
                          <b>{{ $t("consentform.brief") }} </b>
                          <br />
                          <v-textarea
                            hide-details
                            auto-grow
                            row-height="25"
                            outlined
                            dense
                            clearable
                            name="input-7-4"
                            :label="$t('consentform.brief')"
                            v-model="ShortConsent"
                          >
                            <!-- :rules="[(v) => !!v || $t('consentform.brief2')]" -->
                          </v-textarea>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="12">
                          <b class="red--text mr-1">*</b>
                          <b v-if="$t('default') === 'th'"
                            >ข้อมูลที่ต้องการขอ
                          </b>
                          <b v-else>Personal Data to Request </b>
                          <v-combobox
                            color="#077893"
                            v-model="itemsRequest"
                            :items="itemsRequest"
                            required
                            persistent-hint
                            append-icon=""
                            hide-selected
                            multiple
                            outlined
                            dense
                            clearable
                            small-chips
                            deletable-chips
                          >
                          </v-combobox>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n5">
                          <b class="red--text mr-1">*</b>
                          <b v-if="$t('default') === 'th'">Tag Source </b>
                          <b v-else> Tag Source </b>
                          <v-combobox
                            color="#077893"
                            v-model="itemsRequestTag"
                            :items="itemsRequestTag"
                            required
                            persistent-hint
                            append-icon=""
                            hide-selected
                            multiple
                            outlined
                            dense
                            clearable
                            small-chips
                            deletable-chips
                          >
                          </v-combobox>
                        </v-col>
                      </v-row>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-2 pb-2>
                    <v-flex xs11 lg10 pb-4>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("consentform.detail") }}</b>
                      <vue-editor
                        v-model="DetailConsent"
                        :editorToolbar="DefaultToolbar"
                      ></vue-editor>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-2 pb-2>
                    <v-flex xs11 lg10 pb-4>
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("consentform.agree") }}</b>
                      <vue-editor
                        v-model="RejectReason"
                        :editorToolbar="DefaultToolbar"
                      ></vue-editor>
                    </v-flex>
                    <v-flex xs11 md10 lg10 pt-2>
                      <b v-if="$t('default') === 'th'" class="red--text">
                        หมายเหตุ : หากบันทึกแล้วจะไม่สามารถแก้ไขความยินยอมได้</b
                      >
                      <b v-else class="red--text"
                        >Note: Once saved, consent cannot be edited.</b
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    mt-n2
                    pb-3
                    pa-3
                  >
                    <v-flex lg2 md2 sm2 xs2 mr-2>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        @click="Fn_SaveDraft"
                        :loading="loadingDaft"
                        >{{ $t("policy.text5") }}</v-btn
                      >
                    </v-flex>
                    <v-flex lg2 md2 sm2 xs2 v-if="DissabledRole == false">
                      <v-btn
                        block
                        dark
                        color="#077893"
                        @click="Fn_Save"
                        :loading="loadingEnable"
                        >{{ $t("policy.text10") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch :title="ShowTitle" :detail="ShowText" />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPending.vue'
import authorization from '@/functions/authorization.js'
import Swal2 from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import { VueEditor } from 'vue2-editor'
import { mapGetters } from 'vuex'

const Toast = Swal2.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
})
export default {
  components: { VueEditor, OverlaySearch },
  data: function () {
    return {
      valid: true,
      HeaderConsent: '',
      DetailConsent: '',
      ShortConsent: '',
      RejectReason: '',
      ExpireIn: '',
      ShowTitle: 'โปรดรอสักครู่...',
      ShowText:
        'ระบบกำลังดำเนินการแจ้งเตือนเพื่อขออนุมัติการสร้างเอกสารความยินยอม',
      DefaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ color: [] }, { size: 56 }, { background: [] }]
      ],
      Role: [],
      addRequest: [],
      itemsRequest: [],
      itemsRequestTag: [],
      addRequestFixTag: '',
      addRequestFix: '',
      DissabledRole: true,
      loadingDaft: false,
      loadingEnable: false,
      loadingDownloadData: false
    }
  },
  computed: {
    ...mapGetters(['DataConsent']),
    ...mapGetters(['RoleAccount']),
    ...mapGetters(['Business']),
    DataCheckRole: {
      get () {
        return this.$store.state.DataCheckRole
      }
    },
    _SelectBusinessId: {
      get () {
        return this.Business.BusinessId || '-'
      }
    },
    _ConsentId: {
      get () {
        return this.DataConsent.ConsentId || '-'
      }
    }
  },
  mounted () {
    this.Fn_CheckRole()
    this.fn_getDataConsent()
  },
  methods: {
    async Fn_CheckRole () {
      var payload = {
        TaxId: this.$cookies.get('TaxIdCMP')
      }
      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'business/GetBusinessCheckRoleApprove',
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === 'OK') {
            this.Role = response.data.Message.RoleApprove
            const roleArray = Array.isArray(this.Role)
              ? this.Role
              : [this.Role]
            const roleLowerCase = roleArray.map((role) => role.toLowerCase())

            const dataCheckRoleArray = Array.isArray(this.DataCheckRole)
              ? this.DataCheckRole
              : [this.DataCheckRole]
            const dataCheckRoleLowerCase = dataCheckRoleArray.map((role) =>
              role.toLowerCase()
            )

            const isSimilar = roleLowerCase.some((role) =>
              dataCheckRoleLowerCase.includes(role)
            )

            if (isSimilar === true || this.Role.length === 0) {
              this.DissabledRole = false
            } else {
              this.DissabledRole = true
            }
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    async fn_getDataConsent () {
      var payload = {
        BusinessId: this.$cookies.get('BusinessId'),
        AccountId: this.$cookies.get('OneAccountId'),
        ConsentId: this._ConsentId,
        RoleAccount: this.$cookies.get('RoleAccountId')
      }
      var Headers = {
        AccountId: this.$cookies.get('OneAccountId')
      }
      var dataEncode = await authorization.encodeDataNew(payload)
      var auth = await authorization.encodeDataNew(Headers)
      var headers = { Authorization: 'Bearer ' + auth }
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            'consent/GetDetailConsent',
          // "http://192.168.22.85:8006/service/consent/GetDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === 'OK') {
            this.ConsentId = response.data.Message[0].ConsentId
            this.HeaderConsent = response.data.Message[0].HeaderConsent
            this.DetailConsent = response.data.Message[0].DetailsConsent
            this.ShortConsent = response.data.Message[0].ShortConsent
            this.RejectReason = response.data.Message[0].RejectReason
            this.ExpireIn = response.data.Message[0].ExpireIn
            var FixArray = response.data.Message[0].Tag
            if (FixArray == '') {
            } else {
              // FixArray = JSON.parse(FixArray.replace(/'/g, '"'));
              // this.itemsRequest = FixArray.split(", ");
              this.itemsRequest = FixArray.split(',').map((item) =>
                item.trim()
              )
            }
            var FixArrayTag = response.data.Message[0].TagSource
            if (FixArrayTag == '') {
            } else {
              this.itemsRequestTag = FixArrayTag.split(',').map((item) =>
                item.trim()
              )
            }
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.ErrorMessage
            })
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: 'error',
              title: error.response.data.ErrorMessage
            })
          } else if (error.request) {
            Toast.fire({
              icon: 'error',
              title: error.request
            })
          } else {
            Toast.fire({
              icon: 'error',
              title: error.message || error
            })
          }
        })
    },
    async Fn_Save () {
      if (this.$refs.form.validate()) {
        this.loadingEnable = true
        var payload = {
          ConsentId: this.ConsentId,
          BusinessId: this.$cookies.get('BusinessId'),
          AccountId: this.$cookies.get('OneAccountId'),
          AccessToken: this.$cookies.get('OneAccessToken'),
          Title: this.HeaderConsent,
          DetailsConsent: this.DetailConsent,
          RejectReason: this.RejectReason,
          ExpireIn: this.ExpireIn,
          ShortConsent: this.ShortConsent,
          Manage: 'enable',
          Tag: this.itemsRequest.join(', '),
          TagSource: this.itemsRequestTag.join(', ')
        }
        var Headers = {
          AccountId: this.$cookies.get('OneAccountId')
        }
        var dataEncode = await authorization.encodeDataNew(payload)
        var auth = await authorization.encodeDataNew(Headers)
        var headers = { Authorization: 'Bearer ' + auth }
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + 'consent/UpdateConsent',
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingEnable = false

            if (response.data.Status === 'OK') {
              this.ItemPolicy = response.data.Message
              Toast.fire({
                icon: 'success',
                title: response.data.Message
              })
              this.$router.push('/consent-index')
            } else {
              Toast.fire({
                icon: 'error',
                title: response.data.ErrorMessage
              })
            }
          })
          .catch((error) => {
            this.loadingEnable = false
            if (error.response) {
              Toast.fire({
                icon: 'error',
                title: error.response.data.ErrorMessage
              })
            } else if (error.request) {
              Toast.fire({
                icon: 'error',
                title: error.request
              })
            } else {
              Toast.fire({
                icon: 'error',
                title: error.message || error
              })
            }
          })
      }
    },
    async Fn_SaveDraft () {
      if (this.$refs.form.validate()) {
        this.loadingDownloadData = true
        this.loadingDaft = true
        var payload = {
          ConsentId: this.ConsentId,
          BusinessId: this.$cookies.get('BusinessId'),
          AccountId: this.$cookies.get('OneAccountId'),
          AccessToken: this.$cookies.get('OneAccessToken'),
          Title: this.HeaderConsent,
          DetailsConsent: this.DetailConsent,
          RejectReason: this.RejectReason,
          ExpireIn: this.ExpireIn,
          ShortConsent: this.ShortConsent,
          Manage: 'draft',
          Tag: this.itemsRequest.join(', '),
          TagSource: this.itemsRequestTag.join(', ')
        }
        var Headers = {
          AccountId: this.$cookies.get('OneAccountId')
        }
        var dataEncode = await authorization.encodeDataNew(payload)
        var auth = await authorization.encodeDataNew(Headers)
        var headers = { Authorization: 'Bearer ' + auth }
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + 'consent/UpdateConsent',
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDaft = false
            this.loadingDownloadData = false

            if (response.data.Status === 'OK') {
              this.ItemPolicy = response.data.Message
              Toast.fire({
                icon: 'success',
                title: response.data.Message
              })
              this.$router.push('/consent-index')
            } else {
              Toast.fire({
                icon: 'error',
                title: response.data.ErrorMessage
              })
            }
          })
          .catch((error) => {
            this.loadingDaft = false
            this.loadingDownloadData = false
            if (error.response) {
              Toast.fire({
                icon: 'error',
                title: error.response.data.ErrorMessage
              })
            } else if (error.request) {
              Toast.fire({
                icon: 'error',
                title: error.request
              })
            } else {
              Toast.fire({
                icon: 'error',
                title: error.message || error
              })
            }
          })
      }
    },
    Fn_BackIndex () {
      this.$router.push('/consent-index')
    }
  }
}
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>

<style>
span.v-chip--select.v-chip.v-chip--clickable.v-chip--no-color.v-chip--removable.theme--light.v-size--small {
  background-color: #ddf7ff;
}

.mdi-close-circle::before {
  content: "\F0159";
  color: #ff5252;
}
</style>
